import { render } from "./PaiementStripe.vue?vue&type=template&id=52ad7fab&scoped=true&ts=true"
import script from "./PaiementStripe.vue?vue&type=script&lang=ts"
export * from "./PaiementStripe.vue?vue&type=script&lang=ts"

import "./PaiementStripe.vue?vue&type=style&index=0&id=52ad7fab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ad7fab"]])

export default __exports__